// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Folder48FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Folder48Filled: FC<Folder48FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M7 40c-.8 0-1.5-.308-2.1-.925C4.3 38.458 4 37.767 4 37V11c0-.767.3-1.458.9-2.075C5.5 8.308 6.2 8 7 8h14.05l3 3H41c.767 0 1.458.308 2.075.925.617.617.925 1.308.925 2.075v23c0 .767-.308 1.458-.925 2.075-.617.617-1.308.925-2.075.925H7Z" />
        </svg>
    );
};

export default Folder48Filled;
